// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3gok3","boxTitle":"Qualiphy_boxTitle__1AnVb","box":"Qualiphy_box__3d9EK","toggleWrap":"Qualiphy_toggleWrap__3vkWr"};